import servicecenter from "@/views/servicecenter/index.vue"
import regInfo from "@/views/servicecenter/regInfo/index.vue"
import threeRouter from "@/views/threeRouter.vue"
const group = [{
    path: '/servicecenter',
    name: 'servicecenter',
    component: servicecenter,
    redirect: "/servicecenter/pricecomparison",
    meta: { name: "服务中心" },
    children: [{
            name: "regInfo",
            path: "regInfo",
            meta: { name: "注册信息" },
            component: regInfo
        },
        {
            name: "regInfo",
            path: "regInfo",
            component: threeRouter,
            meta: { name: "注册信息" },
            children: [{
                    name: "personal",
                    path: "personal",
                    meta: { name: "编辑" },
                    component: () =>
                        import ("@/views/servicecenter/regInfo/common/personal.vue")
                },
                {
                    name: "company",
                    path: "company",
                    meta: { name: "编辑" },
                    component: () =>
                        import ("@/views/servicecenter/regInfo/common/company.vue")
                },
            ]
        },
        {
            path: "modifypwd",
            name: "modifypwd",
            meta: { name: "修改密码" },
            component: () =>
                import ("@/views/servicecenter/modifypwd/modifypwd.vue")
        },
        {
            path: "margin",
            name: "margin",
            meta: { name: "保证金管理" },
            component: () =>
                import ("@/views/servicecenter/margin/index.vue")
        },
        {
            path: "margin",
            name: "margin",
            meta: { name: "保证金管理" },
            component: threeRouter,
            children: [{
                    path: "topupmargin",
                    name: "topupmargin",
                    meta: { name: "保证金充值" },
                    component: () =>
                        import ("@/views/servicecenter/margin/topupmargin.vue")
                },
                {
                    path: "withdrawal",
                    name: "withdrawal",
                    meta: { name: "保证金提现" },
                    component: () =>
                        import ("@/views/servicecenter/margin/withdrawal.vue")
                }
            ]
        },
        {
            path: "pricecomparison",
            name: "pricecomparison",
            meta: { name: "比价管理" },
            component: () =>
                import ("@/views/servicecenter/pricecomparison/index.vue")
        },
        {
            path: "pricecomparison",
            name: "pricecomparison",
            meta: { name: "比价管理" },
            component: threeRouter,
            children: [{
                path: "payment",
                name: "payment",
                meta: { name: "比价详情" },
                component: () =>
                    import ("@/views/servicecenter/pricecomparison/payment.vue")
            }, {
                path: "pickupgoods",
                name: "pickupgoods",
                meta: { name: "比价详情" },
                component: () =>
                    import ("@/views/servicecenter/pricecomparison/pickUpgoods.vue")
            }, 
            {
                path: "pickup",
                name: "pickup",
                meta: { name: "比价详情" },
                component: () =>
                    import ("@/views/servicecenter/pricecomparison/pickup.vue")
            }, 
            {
                path: "editPickUp",
                name: "editPickUp",
                meta: { name: "比价编辑" },
                component: () =>
                    import ("@/views/servicecenter/pricecomparison/editPickUp.vue")
            }, 
        ]
        },
    ]
}, ]
export default group


// WEBPACK FOOTER //
// ./src/router/servicecenter/index.js